import { ArrowBack } from '@mui/icons-material';
import { BakeasyIconButton, BakeasyIconButtonProps } from './BakeasyIconButton';

export function BakeasyIconButtonBack(props: BakeasyIconButtonProps) {
  return <BakeasyIconButton {...props} icon={<ArrowBack sx={{ fontSize: 24 }} />} />;
}
